<template>
    <button class="download-btn" @click="download">
        <div class="fa-solid fa-download"></div>
    </button>
</template>

<script>
import { mapState } from 'vuex'
import { resolveDataLocation } from '@/constants'

const API_BASE = process.env.VUE_APP_API_BASE_URL || 'https://weather.ecusr.ncu.edu.tw/api'

export default {
    name: 'DownloadButton',
    computed: {
        ...mapState(['selectedStation']),
        // 新站點在後端建立前借用既有的 location，匯出必須跟著指向同一處
        dataLocation() {
            return resolveDataLocation(this.selectedStation)
        },
    },
    methods: {
        download() {
            const url = `${API_BASE}/export_file/?lang=${this.$i18n.locale}&location=${this.dataLocation}`
            const a = document.createElement('a')
            a.href = url
            a.click()
            a.remove()
        },
    },
}
</script>

<style lang="scss" scoped>
.download-btn {
    cursor: pointer;
    border: 1px solid #ccc;
    background-color: #f0f0f0;
    padding: 5px 6px;
    border-radius: 4px;
    &:hover {
        background-color: #e0e0e0;
    }
}
</style>
